var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-mh",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b5aa3",
    d: "M0 0h511.9v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.06 1.24l-5.4 87.963-23.12-56.095 8.87 59.71-35.796-48.252L107.08 99.62 60.067 63.154l36.592 45.826-53.14-23.552 46.549 35.244-57.895-7.655 54.706 21.687-85.871 7.854 86.083 5.754-54.547 22.427 57.311-7.755-46.377 34.245 53.819-23.615-36.708 46.202 46.7-35.358-23.136 53.817 37.382-46.801-10.119 58.338L134.93 195.3l5.315 86.112 8.293-85.9 20.274 54.844-7.73-59.095 37.199 46.84-24.441-54.707 46.68 37.649-37.112-47.005 55.48 23.1-49.101-35.857 59.797 10.08-57.246-21.987 89.038-5.53-89.038-8.292 58.605-19.535-60.733 7.629 50.18-35.082-56.558 22.75 39.06-47.352-47.565 37.146 22.888-56.832-36.92 48.327 7.93-60.27-21.963 56.868-8.204-87.962z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 498.22L511.94 0l-.03 92.71L0 512v-13.78z",
    fill: "#e2ae57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.918 511.98l494.08-320.81-.11-101.85L-.002 512l17.918-.02z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/mh.31263480172a126353544a1ca1d8d0dc.svg";
export { ForwardRef as ReactComponent };